import { TAGS, api } from "@/store/api"
import type {
  ICreateDepositInvoiceArgs,
  ICreateDepositInvoiceResponse
} from "./deposit.types"

const basePath = "/deposit"

export const depositApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.DEPOSIT]
})

export const depositEndpoints = depositApi.injectEndpoints({
  endpoints: (builder) => ({
    createDepositInvoice: builder.mutation<
      ICreateDepositInvoiceResponse,
      ICreateDepositInvoiceArgs
    >({
      query: (data) => ({
        url: basePath,
        method: "POST",
        data
      })
    })
  })
})

export const { useCreateDepositInvoiceMutation } = depositEndpoints
